import React from "react";
import { useAuth } from "@/lib/auth";
import { Card, CardContent } from "@/components/ui/card";
import { ROLE_LABELS } from "@/lib/roles";
import { User, Mail, Phone, Building2 } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="max-w-2xl space-y-6" data-testid="profile-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Profile</div>
        <h1 className="text-2xl sm:text-3xl font-heading font-semibold">My Profile</h1>
      </div>
      <Card>
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-[#0F2942] flex items-center justify-center text-white font-heading font-bold text-2xl">
              {(user.name || "U").split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase()}
            </div>
            <div>
              <div className="text-xl font-heading font-semibold">{user.name}</div>
              <div className="text-sm text-slate-500">{ROLE_LABELS[user.role]}</div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t">
            <div className="flex items-start gap-3"><Mail className="w-4 h-4 mt-1 text-slate-500" /><div><div className="text-xs uppercase tracking-wider text-slate-500">Email</div><div className="text-sm font-medium">{user.email}</div></div></div>
            <div className="flex items-start gap-3"><Phone className="w-4 h-4 mt-1 text-slate-500" /><div><div className="text-xs uppercase tracking-wider text-slate-500">Phone</div><div className="text-sm font-medium">{user.phone || "—"}</div></div></div>
            <div className="flex items-start gap-3"><User className="w-4 h-4 mt-1 text-slate-500" /><div><div className="text-xs uppercase tracking-wider text-slate-500">Role</div><div className="text-sm font-medium">{ROLE_LABELS[user.role]}</div></div></div>
            <div className="flex items-start gap-3"><Building2 className="w-4 h-4 mt-1 text-slate-500" /><div><div className="text-xs uppercase tracking-wider text-slate-500">Municipal Body</div><div className="text-sm font-medium">{user.municipal_body || "—"}</div></div></div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
